import ResumeSkills from "./ResumeSkils";

export default ResumeSkills;
